import React from 'react'
import styled from 'styled-components'
import Header from '../../commons/Header'
import Footer from '../../commons/footer/Footer'
import H1 from '../../commons/H1'
import P from '../../commons/P'
import CommonsLink from '../../commons/Link'
const LandingAccessibilita = () => {
  return (
    <>
      <Header/>
      <Main>
        <Container>
          <StyledH1>
            ACCESSIBILITA'
          </StyledH1>
          <StyledP>
            In linea con gli esiti delle verifiche effettuate da soggetti terzi specializzati, l'azienda ha pubblicato la presente Dichiarazione di Accessibilità e comunica che sta attuando un piano di rimediazione e di miglioramento continuo, finalizzato al costante monitoraggio e al progressivo innalzamento dei livelli di accessibilità dei propri servizi digitali.
          </StyledP>
          <CommonsLink
            link={`${process.env.PUBLIC_URL}/uploads/1790239921525_253950795_2026_08_14_https_www_quintopuoi_it_ACR_IT.pdf`}
            text={'DICHIARAZIONE DI ACCESSIBILITÀ'}
            target={'_blank'}
          />
        </Container>
      </Main>
      <Footer/>
    </>
  )
}

const Main = styled.main`
  padding-top: 20rem;
  min-height: 60vh;
`

const Container = styled.div`
  max-width: 1140px;
  width: 100%;
  margin: 0 auto;
`

const StyledH1 = styled(H1)`
text-align: center;
`

const StyledP = styled(P)`
  text-align: left;
  padding-top: 5rem;

`

export default LandingAccessibilita